export const POSITION_TO_ALLOCATE_TO_AGENCIES_IN_LISTINGS_GD = 9;
